import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function InUnitedStatesField({ onChange, id }) {
  return (
    <select id={id} className={classNames('form-select')} required defaultValue="" onChange={onChange}>
      <option value="" disabled hidden>
        Choose an option
      </option>
      <option value="yes">Yes</option>
      <option value="no">No</option>
    </select>
  );
}

InUnitedStatesField.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default InUnitedStatesField;
